import React, { useState, useEffect } from 'react';

import { withRouter, Route, Switch } from 'react-router-dom';

import EditAward from './EditAward';
import EditRecipients from './EditRecipients';
import ListRecipients from './ListRecipients';
import EditYears from './EditYears';
import ListYears from './ListYears';
import EditInformation from './EditInformation';
import ListInformation from './ListInformation';

import store from 'root/admin/store';
import { TabMenu, MenuItem } from '@smartplatform/ui';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

const menuItems = [
	{
		label: 'Награда',
		id: '',
	},
	{
		label: 'Получатели награды',
		id: 'awardrecipients',
	},
	{
		label: 'Информация',
		id: 'awardinformations',
	},
	{
		label: 'Года присуждений',
		id: 'awardyears',
	},
];

@withRouter
@observer
export default class AwardEdit extends React.Component {
	@observable tab;
	@observable showMenuItems;

	@action switchTab = record => {
		const { id } = this.props.match.params;
		this.tab = record.id;
		console.log(this.tab);
		this.props.history.push(`/admin/awards/${id}/${record.id}`);
		// store.ui.setPage(record.id);
	};
	render() {
		const { id } = this.props.match.params;
		console.log('id from edit', id);
		// const { rootPath } = this.props;
		const rootPath = `${this.props.rootPath}/awards`;
		const menuItemsToShow = !isNaN(id) ? menuItems : [menuItems[0]];
		return (
			<>
				<TabMenu>
					{menuItemsToShow.map(record => (
						<MenuItem
							key={`category-${record.id}`}
							label={record.label}
							onClick={() => this.switchTab(record)}
							active={store.ui.page === record.id}
						/>
					))}
				</TabMenu>
				<Route
					exact
					path={`${rootPath}/:id`}
					component={() => (
						<EditAward setShowMenuItems={this.setShowMenuItems} rootPath={rootPath} tabName={menuItems[0].id} />
					)}
				/>
				<Route
					exact
					path={`${rootPath}/:id/${menuItems[1].id}`}
					component={() => <ListRecipients rootPath={rootPath} tabName={menuItems[1].id} />}
				/>
				<Route
					exact
					path={`${rootPath}/:id/${menuItems[1].id}/:rid`}
					component={() => <EditRecipients rootPath={rootPath} tabName={menuItems[1].id} />}
				/>
					<Route
						exact
						path={`${rootPath}/:id/${menuItems[2].id}`}
						component={() => <ListInformation rootPath={rootPath} tabName={menuItems[2].id} />}
					/>
					<Route
						exact
						path={`${rootPath}/:id/${menuItems[2].id}/:iid`}
						component={() => <EditInformation rootPath={rootPath} tabName={menuItems[2].id} />}
					/>
				<Route
					exact
					path={`${rootPath}/:id/${menuItems[3].id}`}
					component={() => <ListYears rootPath={rootPath} tabName={menuItems[3].id} />}
				/>
				<Route
					exact
					path={`${rootPath}/:id/${menuItems[3].id}/:yid`}
					component={() => <EditYears rootPath={rootPath} tabName={menuItems[3].id} />}
				/>
			</>
		);
	}
}
